var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContentEditOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.05 4.725l4.25 4.2L20.725 7.5a1.81 1.81 0 00.55-1.387 1.983 1.983 0 00-.6-1.388l-1.4-1.4a1.92 1.92 0 00-1.412-.575 1.92 1.92 0 00-1.413.575l-1.4 1.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M19.3 8.925L20.725 7.5a1.81 1.81 0 00.55-1.387 1.983 1.983 0 00-.6-1.388l-1.4-1.4a1.92 1.92 0 00-1.412-.575 1.92 1.92 0 00-1.399.56l-.014.015-1.4 1.4 4.25 4.2zM17.85 10.4L7.25 21H3v-4.25l10.6-10.6 4.25 4.25zM13.6 8.978l1.422 1.422-8.6 8.6H5v-1.422l8.6-8.6z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentEditOutline);
export default __webpack_public_path__ + "57a58ab89ac97dad57261bdaa8a8506d.svg";
export { ForwardRef as ReactComponent };